import useAsyncData from "../../../../hooks/use-async-data";
import cargoCompanyService from "../../cargo-company.service";
import CargoCompanyCargoTaxiContracts from "./cargo-company-cargo-taxi-contracts";
import CargoCompanyCargoTaxiContractsParams from "./cargo-company-cargo-taxi-contracts-params";

const useCargoCompanyCargoTaxiContracts = () => {
  const { data, setData, isError, setIsError, isLoading, setIsLoading } =
    useAsyncData<CargoCompanyCargoTaxiContracts>([]);

  const load = async (
    params: CargoCompanyCargoTaxiContractsParams,
    abortSignal: AbortSignal,
  ): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const cargoCompanyCargoTaxiContracts =
        await cargoCompanyService.fetchCargoTaxiContractsListing(
          params,
          abortSignal,
        );

      setData(cargoCompanyCargoTaxiContracts);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isLoading,
    isError,
    load,
  };
};

export default useCargoCompanyCargoTaxiContracts;
